module.exports = __webpack_public_path__ + "img/40_00_078_528.b71ad648.jpg";